import { render, staticRenderFns } from "./PromptBox.vue?vue&type=template&id=9ad40e62&scoped=true"
import script from "./PromptBox.vue?vue&type=script&lang=js"
export * from "./PromptBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad40e62",
  null
  
)

export default component.exports